import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { rateCardUrl, services } from "@/data/eventOrganizerContent";

const ServicesSection = () => {
  return (
    <section id="services" data-testid="services-section" className="space-y-10 py-24">
      <div className="max-w-3xl space-y-4">
        <p
          data-testid="services-eyebrow-text"
          className="inline-flex items-center gap-2 rounded-full border border-fuchsia-200 bg-fuchsia-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-fuchsia-700"
        >
          <Sparkles className="h-3.5 w-3.5" />
          Scope of Work
        </p>
        <h2 data-testid="services-heading" className="text-3xl leading-tight text-violet-950 md:text-5xl">
          Conference Production + Speaker Acquisition, Event Management, and Master of Ceremony.
        </h2>
        <p data-testid="services-subheading-text" className="text-sm text-stone-600 md:text-base">
          Primary sections are shown first, with additional corporate support services below.
        </p>
        <Button
          asChild
          variant="outline"
          className="h-10 rounded-full border-fuchsia-300 bg-white text-xs font-semibold uppercase tracking-[0.12em] text-fuchsia-800 hover:bg-fuchsia-50"
          data-testid="services-rate-card-link-button"
        >
          <a href={rateCardUrl} target="_blank" rel="noreferrer" aria-label="Open rate card PDF">
            View Full Rate Card (PDF)
          </a>
        </Button>
      </div>

      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {services.map((service, index) => (
          <Card
            key={service.title}
            data-testid={`services-card-${index + 1}`}
            className="service-card border-fuchsia-200 bg-violet-50/75 shadow-[0_10px_30px_rgba(70,25,95,0.08)]"
          >
            <CardContent className="space-y-5 p-7">
              <div className="space-y-2">
                <span
                  data-testid={`services-card-${index + 1}-group`}
                  className={`inline-flex rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] ${service.group === "Primary" ? "bg-fuchsia-100 text-fuchsia-800" : "bg-violet-100 text-violet-800"}`}
                >
                  {service.group}
                </span>
                <p
                  data-testid={`services-card-${index + 1}-price`}
                  className="text-xs font-semibold uppercase tracking-[0.14em] text-fuchsia-700"
                >
                  {service.price}
                </p>
                <h3
                  data-testid={`services-card-${index + 1}-title`}
                  className="text-2xl leading-tight text-violet-900"
                >
                  {service.title}
                </h3>
                <p
                  data-testid={`services-card-${index + 1}-description`}
                  className="text-sm leading-relaxed text-violet-800/80 md:text-base"
                >
                  {service.description}
                </p>
              </div>

              <ul className="space-y-2">
                {service.highlights.map((item) => (
                  <li
                    key={item}
                    data-testid={`services-highlight-${service.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="rounded-md bg-fuchsia-100/70 px-3 py-2 text-sm text-violet-900"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;